import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import classNames from 'classnames';
import Candidate from '../../candidatesList/candidate';
import RichTextPreview from '../../richTextPreview';
import {
  areEqualInMilliseconds,
  formatDate,
  formatTimeAgo,
} from '../../../../utility/dateUtils';
import DotsMenu from '../../dotsMenu';
import ConditionalTooltip from '../../conditionalTooltip';
import { EVENT_DATE_TIME_FORMAT } from '../jobEvent/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    borderBottom: `1px solid ${primary.bluish7}`,
    paddingBottom: spacing(8),
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    minWidth: 'fit-content',
  },
  icon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    marginRight: spacing(3),
  },
  commentIcon: {
    minWidth: 'fit-content',
  },
  candidate: {
    marginTop: spacing(4),
  },
  commentAvatarWrapper: {
    marginTop: 0,
    backgroundColor: `${primary.white}`,
    padding: 0,
    alignItems: 'center',
  },
  comment: {
    marginTop: spacing(4),
  },
  commentWrapper: {
    marginLeft: spacing(9),
  },
  dateLabel: {
    marginRight: spacing(2),
  },
  disabledIcon: {
    opacity: 0.3,
  },
  disabledAction: {
    cursor: 'pointer',
  },
}));

const CommunicationInfo = ({
  translations,
  record,
  icon: CommunicationIcon,
  menuItems = [],
  isDisabledDotsMenu = false,
  tooltipText = '',
}) => {
  const classes = useStyles();
  const daysAgo = formatTimeAgo(record.created_at, translations.candidates);
  const createdAtDate = formatDate(record.created_at, EVENT_DATE_TIME_FORMAT);
  const isEdited = areEqualInMilliseconds(record.updated_at, record.created_at);
  const createdAt = isEdited
    ? `${createdAtDate} ${translations.edited}`
    : createdAtDate;

  return (
    <div className={classes.root}>
      <div className={classes.buttonWrapper}>
        <div className={classes.infoWrapper}>
          <div className={classes.icon}>
            <CommunicationIcon className={classes.commentIcon} />
          </div>
          <Candidate
            className={classNames(
              classes.candidate,
              classes.commentAvatarWrapper
            )}
            user={record.author}
            label={daysAgo}
            hasLabel
          />
        </div>
        <div className={classNames(classes.infoWrapper, classes.wrapper)}>
          <Typography
            variant="overline"
            className={(classes.infoWrapper, classes.dateLabel)}
          >
            {createdAt}
          </Typography>
          <ConditionalTooltip
            className={classes.disabledAction}
            message={tooltipText}
            addTooltip={isDisabledDotsMenu}
          >
            <DotsMenu
              menuItems={menuItems}
              isDisabled={isDisabledDotsMenu}
              iconButtonClass={classNames({
                [classes.disabledIcon]: isDisabledDotsMenu,
              })}
            />
          </ConditionalTooltip>
        </div>
      </div>
      <RichTextPreview
        variant="body1"
        className={classNames(classes.comment, classes.commentWrapper)}
        text={record.content || record.body}
      />
    </div>
  );
};

CommunicationInfo.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
  icon: PropTypes.object.isRequired,
  isDisabledDotsMenu: PropTypes.bool,
  tooltipText: PropTypes.string,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})),
};

export default CommunicationInfo;
